'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var gqlUtils = require('@liquorice/gql-utils');
var reactHookForm = require('react-hook-form');
var FIELD_BASE_FRAGMENT = require('../lib/parse/FIELD_BASE_FRAGMENT.js');
var parseFieldBase = require('../lib/parse/parseFieldBase.js');
var DefaultTextField = require('./DefaultTextField/DefaultTextField.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const Field_Text = gqlUtils.withFragment(FIELD_BASE_FRAGMENT.FIELD_BASE_FRAGMENT, (data, { methods })=>{
    const field = parseFieldBase(data);
    if (!field) return null;
    const { defaultValue, handle, label, placeholder, required, instructions } = field;
    const fieldProps = {
        // error: !!error,
        helperText: instructions,
        label,
        placeholder,
        required
    };
    switch(field.__typename){
        case 'Field_MultiLineText':
            fieldProps.multiline = true;
            fieldProps.minRows = 3;
            break;
        case 'Field_Email':
            fieldProps.type = 'email';
            break;
        case 'Field_Number':
            fieldProps.type = 'number';
            break;
        case 'Field_Phone':
            fieldProps.type = 'tel';
            break;
        case 'Field_Hidden':
            fieldProps.type = 'hidden';
            fieldProps.hidden = true;
            break;
    }
    return /*#__PURE__*/ jsxRuntime.jsx(reactHookForm.Controller, {
        name: handle,
        control: methods.control,
        defaultValue: defaultValue != null ? defaultValue : '',
        render: (_param)=>{
            var { field: { ref }, fieldState: { error } } = _param, rest = _object_without_properties_loose(_param.field, [
                "ref"
            ]);
            return /*#__PURE__*/ jsxRuntime.jsxs(jsxRuntime.Fragment, {
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx(DefaultTextField.DefaultTextField, _extends({}, rest, {
                        error: !!error
                    }, fieldProps, {
                        inputProps: {
                            ref
                        }
                    })),
                    /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                        errors: error
                    })
                ]
            });
        }
    });
});

exports.Field_Text = Field_Text;
